import { Box, BoxProps, CSS, keyframes } from '@project44/manifest-ds';

import { skeletonColors } from './constants';

interface Props extends BoxProps {
  css?: CSS;
  asSpan?: boolean;
}

const shine = keyframes({
  '0%': {
    backgroundPosition: '0 0',
  },
  '100%': {
    backgroundPosition: '500px 0',
  },
});

const gradient = `
  linear-gradient(90deg,
    rgba(213, 215, 217, 0.8) 0%,
    ${skeletonColors.secondary} 33%, ${skeletonColors.secondary} 66%,
    rgba(213, 215, 217, 0.8) 100%);
`;

export const Skeleton: React.FC<Props> = ({ css, asSpan }) => (
  <Box
    data-testid="skeleton"
    as={asSpan ? 'span' : 'div'}
    css={{
      animation: `${shine} 1.8s linear infinite`,
      background: gradient,
      backgroundSize: '500px 100%',
      borderRadius: '4px',
      height: '14px',
      width: '100%',
      ...css,
    }}
  />
);
